import { centsAsDecimal } from '../utils/money';
import { track, userId } from './shared';

const productIds = (cartData) => cartData.items.map((item) => `shopify_US_${item.product_id}_${item.variant_id}`);

const productNames = (cartData) => cartData.items.map((item) => `${item.product_title}`);

const productCategories = (cartData) => cartData.items.map((item) => `${item.product_type}`);

const productValues = (cartData) => cartData.items.map((item) => `${centsAsDecimal(item.price)}`);

const buildData = (cartData) => ({
  ecomm_prodid: productIds(cartData),
  ecomm_pname: productNames(cartData),
  ecomm_pcat: productCategories(cartData),
  ecomm_pvalue: productValues(cartData),
  ecomm_pagetype: 'cart',
  ecomm_totalvalue: centsAsDecimal(cartData.total_price),
  user_id: userId()
});

const googleTagCart = ({ cartData }) => {
  track({ eventName: 'dynamicRemarketingTriggered', data: { google_tag_params: buildData(cartData) }});
};

export default googleTagCart;
